<template>
  <v-app>
    <notifications group="home-notifications" width="400">
      <template v-slot:body="props">
        <v-row>
          <v-col>
            <div class="white ma-4">
              <NotificationAlert :data="props.item.data"></NotificationAlert>
            </div>
          </v-col>
        </v-row>
      </template>
    </notifications>

    <nav-bar />

    <left-nav-bar v-if="isAuthenticated" />

    <v-main class="bg">
      <transition name="fade">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import NavBar from "./app/core-module/components/NavBar";
import LeftNavBar from "./app/core-module/components/LeftNavBar";
import NotificationAlert from "@/app/core-module/components/NotificationAlert";

import {
  saveLanguage,
  setLanguage,
} from "./app/core-module/util/languageHelper";
import { initAuthHelper, saveUser } from "./app/user-module/helpers/authHelper";

export default {
  name: "App",
  components: { NotificationAlert, NavBar, LeftNavBar },
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
  },
  apollo: {
    getAppData() {
      return {
        query: require("./app/core-module/api/query/getAppData.gql"),
        result({ data, loading }) {
          if (data && data.getAppData) {
            if (data.getAppData.appSettings) {
              if (
                data.getAppData.appSettings.supportedCurrencies &&
                data.getAppData.appSettings.supportedCurrencies.length
              ) {
                this.$store.commit(
                  "SET_SUPPORTED_CURRENCIES",
                  data.getAppData.appSettings.supportedCurrencies
                );
              }

              if (
                data.getAppData.appSettings.currencyTable &&
                data.getAppData.appSettings.currencyTable.items
              ) {
                this.$store.commit(
                  "SET_CURRENCY_TABLE",
                  data.getAppData.appSettings.currencyTable
                );
              }
            }

            if (data.getAppData.user) {
              saveUser(data.getAppData.user);
            }

            if (data.getAppData.subscriptionInfo) {
              this.$store.commit(
                "SET_SUBSCRIPTION_INFO",
                data.getAppData.subscriptionInfo
              );
            }
          }
        },
      };
    },
    getNotifications() {
      return {
        query: require("./app/core-module/api/query/getNotifications.gql"),
        variables: {
          pageInput: {
            skip: 0,
            limit: 10,
          },
        },
        subscribeToMore: {
          document: require("./app/core-module/api/subscription/onNotification.gql"),
          updateQuery: (previousResult, { subscriptionData }) => {
            const existingResult = { ...previousResult };

            const existingIndex =
              existingResult.getNotifications?.notifications?.findIndex(
                x =>
                  x._id.toString() ===
                  subscriptionData.data?.onNotification?._id?.toString()
              );

            if (existingIndex < 0) {
              existingResult.getNotifications?.notifications?.unshift(
                subscriptionData.data?.onNotification
              );

              this.showNotification({
                title: this.getLocalisedValue(
                  subscriptionData.data?.onNotification?.title
                ),
                body: this.getLocalisedValue(
                  subscriptionData.data?.onNotification?.message
                ),
                data: subscriptionData.data?.onNotification,
              });
            }

            return existingResult;
          },
        },
      };
    },
    getSubscriberProfile() {
      return {
        query: require("./app/user-module/api/query/getSubscriberProfile.gql"),
        result({ data }) {
          if (data?.getSubscriberProfile) {
            this.$store.commit(
              "SET_SUBSCRIBER_INFO",
              data.getSubscriberProfile
            );
          }
        },
        skip: () => !this.isAuthenticated,
      };
    },
  },
  created() {
    initAuthHelper();

    this.$vuetify.theme.dark =
      this.readFromLocalStorage("ThemeMode") === "dark";
  },
  watch: {
    "$route.params.lang": {
      handler(newValue) {
        if (newValue != null) {
          setLanguage(newValue, false);
          saveLanguage(newValue);
          this.$vuetify.rtl = newValue === "ar";
        }
      },
    },
    isAuthenticated() {
      if (this.isAuthenticated) {
        this.$apollo.queries.getSubscriberProfile?.refetch();
      }
    },
  },
  methods: {
    showNotification({ title, body, data }) {
      try {
        this.$notification.show(title, { body }, {});
      } catch (e) {
        console.log("showNotification:native:", e.message);
      }

      if (this.$route.name !== "Home") {
        try {
          this.$notify({
            group: "home-notifications",
            title,
            text: body,
            data,
          });
        } catch (e) {
          console.log("showNotification:page:", e.message);
        }
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.no-background-hover::before {
  background-color: transparent !important;
}
</style>
